module.exports = __webpack_public_path__ + "static/media/isobau_2.173c9807.gif";